<div class="archive-tab">
  <div class="archive-header">
    <div class="scope-selector">
      <label class="label">Gebäudeteil</label>
      <nb-select fullWidth
                 [selected]="''"
                 (selectedChange)="onScopeChange($event)">
        <nb-option value="">Unzugewiesen</nb-option>
        @for (section of sections(); track section.id) {
          <nb-option [value]="section.id">{{ section.sectionText }}</nb-option>
        }
      </nb-select>
    </div>
    @if (multiAttachmentControl()?.selectedFiles?.length) {
      <button nbButton
              status="info"
              size="small"
              (click)="reassignFiles()">
        <nb-icon icon="swap-outline" pack="eva"></nb-icon>
        Zuweisen ({{ multiAttachmentControl()!.selectedFiles.length }})
      </button>
    }
  </div>

  @if (formWrapper().form(); as form) {
    <wr-multi-attachment-control [formControl]="form.controls.archiveImages"
                                 [filterBuildingSectionId]="selectedSectionId()">
    </wr-multi-attachment-control>
  }
</div>
